export default class faqAccordion {
    constructor() {
        this.settings = {
            el: document.querySelectorAll(".js-faq-accordion-btn"),
            categoryButtons: document.querySelectorAll(".js-faq-category-button"),
            defaultCategoryFilter: null,
        };

        if (this.settings.el.length) {
            this.settings.defaultCategoryFilter = document.getElementById("default_category_to_show_slug").value;
        }
    
        this.bindUIActions();
    
        if (this.settings.defaultCategoryFilter) {
            this.filterItems(this.settings.defaultCategoryFilter);
            this.setInitialCategoryButtonStyle(this.settings.defaultCategoryFilter);
        }
    }

    setInitialCategoryButtonStyle(defaultCategorySlug) {
        if(this.settings.el.length) {
            this.settings.categoryButtons.forEach(button => {
                const buttonSlug = button.getAttribute("data-faq-filter");
                if (buttonSlug === defaultCategorySlug) {
                    button.classList.remove('btn--outline');
                    button.classList.add('btn--black');
                }
            });
        }
    }

    bindUIActions() {
        if(this.settings.el.length) {
            const hideAllItems = () => {
                this.settings.el.forEach(element => {
                    element.parentElement.style.display = "none";
                });
            }

            const filterItems = (filter) => {
                hideAllItems();
            
                this.settings.el.forEach(element => {
                    const category = element.parentElement.getAttribute("data-faq-category");
                    if (category === filter) {
                        element.parentElement.style.display = "block";
                    }
                });
            }

            this.settings.categoryButtons.forEach(button => {
                button.addEventListener("click", function() {
                    document.querySelectorAll('.js-faq-category-button').forEach(btn => {
                        btn.classList.remove('btn--black');
                        btn.classList.add('btn--outline');
                    });

                    this.classList.remove('btn--outline');
                    this.classList.add('btn--black');

                    const filterSlug = button.getAttribute("data-faq-filter");
                    filterItems(filterSlug);
                });
            });

            for (let i = 0; i < this.settings.el.length; i++) {
                this.settings.el[i].addEventListener("click", function (e) {
                    const icon = this.querySelector('i');

                    const panel = e.currentTarget.nextElementSibling;
                    panel.classList.toggle("open");

                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                        icon.classList.remove("rotate-45");
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                        icon.classList.add("rotate-45");
                    }
                });
            }
        }
    }

    filterItems(filter) {
        if(this.settings.el.length) {
            const hideAllItems = () => {
                this.settings.el.forEach(element => {
                    element.parentElement.style.display = "none";
                });
            }

            hideAllItems();

            this.settings.el.forEach(element => {
                const category = element.parentElement.getAttribute("data-faq-category");
                if (category === filter) {
                    element.parentElement.style.display = "block";
                }
            });
        }
    }

}

new faqAccordion();